export default "__VITE_ASSET__Bbu_XbZE__"